import { helpers } from 'vuelidate/lib/validators';

export const EMAIL_REGEXP =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MIN_PASSWORD_LENGTH = 6;
export const LINK_REGEXP =
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

export const LINKED_IN_REGEXP =
  /^(?:http(s)?:\/\/)?([\w]+\.)?linkedin\.(com|cn)(\/mwlite|\/m)?\/in\/([^=^"'{}<>!#?$*&,.:;()[\]_\s]+)\/?$/i;
export const TWITTER_REGEXP = /http(s)?:\/\/(.*\.)?twitter\.com\/[A-z0-9_]+\/?/i;
export const FACEBOOK_REGEXP = /http(s)?:\/\/(www\.)?(facebook|fb)\.com\/[A-z0-9_\-.]+\/?/i;
export const INSTAGRAM_REGEXP =
  /https?:\/\/(www\.)?instagram\.com\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/i;
export const YOUTUBE_REGEXP =
  /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
export const PAYPAL_REGEXP = /^(?:http(s)?:\/\/)?(www\.)?paypal\.me\/[A-z0-9_]+\/?/i;

// rules
export const required = value => value != null && String(value).trim().length !== 0;
export const minLength = (value, length) => String(value).length >= length;
export const email = value => required(value) && EMAIL_REGEXP.test(String(value));
export const password = value => required(value) && minLength(value, MIN_PASSWORD_LENGTH);
export const link = value => LINK_REGEXP.test(value);

// test rule against the value
export const test = (value, rule, message) => (!rule(value) && message) || null;

export const linkedInUrl = value => LINKED_IN_REGEXP.test(String(value));
export const twitterUrl = value => TWITTER_REGEXP.test(String(value));
export const facebookUrl = value => FACEBOOK_REGEXP.test(String(value));
export const instagramUrl = value => INSTAGRAM_REGEXP.test(String(value));
export const emptyStringOrLinkedInUrl = value => !value.length || linkedInUrl(value);

// valid value e.g. lol-kek-cheburek
export const slug = helpers.regex('slug', /^[a-zA-Z0-9-]*$/);

// digits, comas, dots and spaces
export const revenue = helpers.regex('revenue', /^[0-9,.\s]+$/);
